/**
 * Die zwei Anreicherungsfelder der Anlage-Nutzlast — Modus `new` und PO-Schnellweg.
 *
 * Owner-Entscheid A (2026-10-26): die Anreicherung läuft bei **jeder** Anlage
 * über den Assistenten, auch ohne Quellen — der n8n-Workflow recherchiert dann
 * selbst über Produktname und Hersteller. Der Opt-out-Schalter ist gefallen;
 * ein Schalter wäre eine zweite Wahrheit gegen „immer“.
 *
 * Warum eine eigene Datei: der Assistent ist sieben Schritte lang, und eine
 * Probe, die ihn durchklickt, prüft am Ende die Formularvalidierung statt
 * dieser zwei Felder. Hier steht nur die Form, und sie ist ohne Dialog
 * prüfbar (`anreicherungNutzlast.test.js`).
 *
 * 🔴 **Der Modus `new` — und seit dem 2026-10-27 der PO-Schnellweg.** Der
 * Basismodus (Schnellweg) baut seine Nutzlast an anderer Stelle
 * (`handleBasicSubmit` in `UnifiedCreateWizard.jsx`). Zwei Fakten galten dort
 * bis PR2 ohne Ausnahme: (a) diese Funktion war im Schnellweg nicht
 * angeschlossen, und (b) der Schnellweg sendete `skip_n8n_enrichment: true`
 * ohne `ai_enrichment` — Owner-Entscheid A (2026-10-26) nimmt Ersatzteile über
 * den Schnellweg aus.
 *
 * Beides gilt weiter für den **Ersatzteil-Dialog** (`SparePartCreateDialog`) und
 * die **RMA-Auswahl** (`ReplacementProductPicker`): sie setzen kein
 * `sourceContext`, und dort ist diese Funktion NICHT angeschlossen.
 * **Ausgenommen ist der PO-Schnellweg** (`sourceContext: 'po'`, nur
 * `PODetail.jsx`): er sendet `...baueAnreicherungsFelder({})` — Owner auf die
 * Rückfrage „KI-Anreicherung auch im PO-Schnellweg?“ (2026-10-27): „1. ja“.
 *
 * @param {object} eingaben
 * @param {string[]} [eingaben.sourceUrls]   bereinigte Quellen-URLs, dürfen leer sein
 * @param {string[]} [eingaben.imageUrls]    bereinigte Bild-URLs, dürfen leer sein
 * @param {string}   [eingaben.promptText]   Freitext, wird getrimmt
 * @param {string}   [eingaben.promptDocUrl] Google-Doc-URL, wird getrimmt
 * @param {object}   [eingaben.updateOptions] Zusatzaufträge (notify, varianten_farben …)
 * @returns {{skip_n8n_enrichment: boolean, ai_enrichment: object}}
 */
export function baueAnreicherungsFelder({
  sourceUrls = [],
  imageUrls = [],
  promptText = '',
  promptDocUrl = '',
  updateOptions = {},
} = {}) {
  const aiEnrichment = {
    // products_v2.py gates the webhook on this flag — without it nothing fires.
    enabled: true,
    // Leere Listen bleiben leer: die Queue-Spalte ist NOT NULL default list,
    // der Webhook trägt `[]`.
    source_urls: Array.isArray(sourceUrls) ? sourceUrls : [],
    image_urls: Array.isArray(imageUrls) ? imageUrls : [],
  };

  const text = (promptText || '').trim();
  if (text) aiEnrichment.prompt_text = text;

  const docUrl = (promptDocUrl || '').trim();
  if (docUrl) aiEnrichment.prompt_doc_url = docUrl;

  if (updateOptions && Object.keys(updateOptions).length) {
    aiEnrichment.update_options = updateOptions;
  }

  return { skip_n8n_enrichment: false, ai_enrichment: aiEnrichment };
}
